import { useState, useContext } from 'react';
import _isNil from 'lodash/isNil';
import _isEmpty from 'lodash/isEmpty';

import { ModalContext, AppContext, AsyncSelect } from 'commons-ui';
import useService from '../../useService';
import { FORM_FIELD_CONFIG, FORM_FIELD_KEYS } from './formConfig';
import { UserDetailsContext } from '../../../../../context/userDetails';

const useContent = () => {
	const [, setForceUpdate] = useState<boolean>(false);
	const { makeUserSupportAutomatedCall, getCampaignOptions } = useService(setForceUpdate);

	const [showLoader, setShowLoader] = useState(false);
	const { setModalConfig } = useContext(ModalContext);
	const { showAlert } = useContext(AppContext);
	const { selectedUser } = useContext(UserDetailsContext);
	const hasAlternatePhone = Boolean(selectedUser?.alternatePhoneNumber);

	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.PHONE_TYPE].setRenderer(AsyncSelect).setRenderProps({
		isEditable: { create: true, edit: true },
		required: true,
		getOptions: async () =>
			hasAlternatePhone
				? [
						{ id: 'PRIMARY', label: 'Primary' },
						{ id: 'ALTERNATE', label: 'Alternate' }
				  ]
				: [{ id: 'PRIMARY', label: 'Primary' }]
	});
	FORM_FIELD_CONFIG[FORM_FIELD_KEYS.CAMPAIGN_NAME].setRenderProps({ getOptions: getCampaignOptions });
	const handleFormSubmit = async (submittedData: any) => {
		try {
			setShowLoader(true);
			const data = await makeUserSupportAutomatedCall(
				submittedData?.ticketId,
				submittedData?.campaignName,
				submittedData?.agentId,
				submittedData?.phoneType
			);
			if (!_isNil(data) && !_isEmpty(data)) {
				showAlert(data, { type: 'success' });
			}
			setShowLoader(false);
		} catch (error) {
			showAlert('Error in making User Support Call', { type: 'error' });
		} finally {
			setModalConfig({ isOpen: false });
		}
	};

	const handleFormCancel = () => {
		setModalConfig({ isOpen: false });
	};

	return {
		showLoader,
		setShowLoader,
		handleFormCancel,
		handleFormSubmit
	};
};

export default useContent;
